module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (94).25ab74b8.jpg";